import React from 'react';
import { IconContext } from "react-icons";

export function Icon({ icon, style }) {
  if (style == null) {
    style = "";
  }

  return (
    <IconContext.Provider value={style}>
      {icon}
    </IconContext.Provider>
  );
}